import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { editRole, addRole } from '@/api/roleManage';
// import standardTree from '@/components/standardTree/index';

export default {
  name: 'roleModel',
  props: {
    currentRow: [Object, null],
    dialogVisible: Boolean,
    tableData: Array
  },
  // components: { standardTree },
  data() {
    // const validateRole = (rule, value, callback) => {
    //   if (this.currentRow) {
    //     callback();
    //   }
    //   if (value.trim().length === 0) {
    //     callback(new Error('角色名称不能为空！'));
    //   } else if (this.roleList.indexOf(value) != -1) {
    //     callback(new Error('已存在相同角色名称！'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      roleFrom: {
        name: ''
      },
      loading: false
    };
  },
  computed: {
    roleList() {
      return this.tableData.map(item => item.role);
    },
    roleRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入名称')
        }]
      };
    }
  },
  mounted() {
    this.roleFrom = {
      ...this.currentRow
    } || {
      role: ''
    };
  },
  methods: {
    handleSure() {
      this.$refs.roleFrom.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.currentRow) {
            //编辑
            this.roleFrom.roleId = this.currentRow.id;
            editRole(this.roleFrom).then(() => {
              this.$message.success(this.$t('修改成功'));
              this.loading = false;
              this.$emit('ok');
            });
          } else {
            //新增
            addRole(this.roleFrom).then(() => {
              this.$message.success(this.$t('添加成功'));
              this.loading = false;
              this.$emit('ok');
            });
          }
        } else {
          this.loading = false;
        }
      });
    }
  }
};